import AllBeautyFeatures from './Beauty/AllBeautyFeatures';
import BeautyHero from './Beauty/BeautyHero';
import HowItWorksBeauty from './Beauty/HowItWorksBeauty';
import WhyZolaBeauty from './Beauty/WhyZolaBeauty';

function BeautyPage() {
  return (
    <>
    <BeautyHero />
    <WhyZolaBeauty />
    <HowItWorksBeauty />
    <AllBeautyFeatures />
    </>
  )
}

export default BeautyPage